import React from "react"
import logo from "../images/linz-logo-col-n-white-txt.svg"

interface HeaderProps {
  headingText: string
}

export const LuiHeaderLarge: React.FC<HeaderProps> = (props) => {
  return (
    <header className="lui-header-primary">
      <div className="g-flex-container lui-max-width lui-header-top-section">
        <div className="g-flex-row lui-header-cols">
          <div className="lui-header-col-1 linz-logo-container">
            <div className="g-flex-row">
              <div className="lui-header-logo">
                <img className="linz-logo" alt="Linz logo" src={logo} />
              </div>
              <div className="lui-header-title">
                <h1>{props.headingText}</h1>
              </div>
            </div>
          </div>
          {/*<div className="lui-header-col-2">*/}
          {/*  <div className="g-flex-row">*/}
          {/*    <div className="lui-header-user lui-hide-xs lui-hide-sm lui-hide-md">*/}
          {/*      <p><i className="material-icons-round">account_circle</i> Logged in name</p>*/}
          {/*    </div>*/}
          {/*    <div className="lui-header-menu-icon">*/}
          {/*      <button>*/}
          {/*        <i className="material-icons-round md-36">menu</i>*/}
          {/*        <span aria-hidden="true" className="lui-hide-xs lui-hide-sm">Menu</span>*/}
          {/*      </button>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
      <div className="lui-header-swish"></div>
      <div className="g-flex-container lui-max-width lui-header-bottom-section">
        <div className="g-flex-row">
          <div className="g-flex-col g-flex-col-xs-12 lui-text-content-area">
            <h1>{props.headingText}</h1>
          </div>
        </div>
      </div>
    </header>
  )
}
